import styled from '@emotion/styled'
import { WebLink } from '@news-mono/web-common'
import { breakpoint, calcRem, fonts, themedValue } from '../__styling'

const TW_BLACK = '#2B2D2E'
const PN_BLACK = '#252525'
const HR_LINE_COLOR = '#B5B9BA'

export const StyledEmailPreference = styled('div')(({ theme }) => ({
    color: themedValue(theme, {
        thewest: TW_BLACK,
        perthnow: PN_BLACK,
        fallback: TW_BLACK,
    }),
    padding: themedValue(theme, {
        thewest: 0,
        perthnow: calcRem(32, 16, 0),
        fallback: 0,
    }),

    [breakpoint('sm')]: {
        padding: themedValue(theme, {
            thewest: 0,
            perthnow: calcRem(40, 24, 0),
            fallback: 0,
        }),
    },

    [breakpoint('md')]: {
        padding: themedValue(theme, {
            thewest: 0,
            perthnow: calcRem(64, 0, 0),
            fallback: 0,
        }),
    },
}))

export const StyledHeading = styled('h1')(({ theme }) => ({
    fontFamily: themedValue(theme, {
        thewest: fonts.thewest.serif,
        perthnow: fonts.perthnow.sansSerifCond,
        fallback: fonts.thewest.serif,
    }),
    fontWeight: themedValue(theme, {
        thewest: 400,
        perthnow: 700,
        fallback: 400,
    }),
    fontSize: themedValue(theme, {
        thewest: calcRem(39),
        perthnow: calcRem(42),
        fallback: calcRem(39),
    }),
    margin: 0,
    lineHeight: calcRem(48),
}))

export const StyledGreeting = styled('p')(({ theme }) => ({
    fontSize: themedValue(theme, {
        thewest: calcRem(22),
        perthnow: calcRem(24),
        fallback: calcRem(22),
    }),

    fontFamily: themedValue(theme, {
        thewest: fonts.thewest.serif,
        perthnow: fonts.perthnow.sansSerifCond,
        fallback: fonts.thewest.serif,
    }),

    fontWeight: 700,
    margin: calcRem(16, 0, 8, 0),
    lineHeight: calcRem(24),
}))

export const StyledEmail = styled('p')(() => ({
    margin: 0,
    paddingBottom: calcRem(16),
    borderBottom: `1px solid ${HR_LINE_COLOR}`,
}))

export const StyledFooter = styled('div')(({ theme }) => ({
    borderTop: `1px solid ${HR_LINE_COLOR}`,
    h2: {
        fontSize: themedValue(theme, {
            thewest: calcRem(32),
            perthnow: calcRem(36),
            fallback: calcRem(32),
        }),
        fontFamily: themedValue(theme, {
            thewest: fonts.thewest.serif,
            perthnow: fonts.perthnow.sansSerifCond,
            fallback: fonts.thewest.serif,
        }),
        margin: calcRem(32, 0, 16),
        lineHeight: calcRem(40),
    },
}))

export const StyledBody = styled('p')(({ theme }) => ({
    margin: calcRem(32, 0),
    [breakpoint('sm')]: {
        margin: calcRem(40, 0),
    },
    [breakpoint('md')]: {
        margin: calcRem(48, 0),
    },
}))

export const StyledWebLink = styled(WebLink)({
    display: 'block',
    margin: calcRem(16, 0),
    lineHeight: calcRem(24),
})
